import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import now_icon from '../../../asset/icon/now.png';
import { NavItem } from './LeftNavBarMobile';
import { useCheckBeforeMove } from '../../../shared/hooks/useCheckBeforeMove';
import { useMenu } from '../../../shared/hooks/useMenu';


export interface BigMenuProps {
  data: NavItem;
  children?: React.ReactNode;
}

const BigMenu: React.FC<BigMenuProps> = ({ data, children }) => {
  const navigate = useNavigate();
  const { getCurrentPage } = useCheckBeforeMove();
  const { closeMenu } = useMenu();

  const checkIsThisPage = () => {
    const { page } = getCurrentPage();
    return page === data.label.toLowerCase();
  }

  const isThisPage = checkIsThisPage();

  const handleMenuClick = () => {
    if (isThisPage) {
      closeMenu();
      return;
    }
    navigate(data.path);
  };

  return (
    <>
      <BigMenuComp $isVisible={data.isVisible} onClick={handleMenuClick} >
        <NowIconButton $isActive={isThisPage} $backgroundImg={now_icon} />
        <StyledLink $isActive={isThisPage}>
          {data.label}
        </StyledLink>
      </BigMenuComp>
      {children}
    </>
  )
}

const BigMenuComp = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  height: clamp(35px, 5vh, 42px);
  display: flex;
  align-items: center;
  overflow: hidden;
  color: ${({ $isVisible, theme }) => $isVisible ? theme.colors.color_Gray_01 : theme.colors.color_Gray_05};
  cursor: pointer;
`;

const StyledLink = styled.div<{ $isActive: boolean; }>`
  text-decoration: ${({ $isActive }) => $isActive ? 'underline' : 'none'};
  ${({ theme }) => theme.typography.Body_04};
  cursor: pointer;
`;

const NowIconButton = styled.div<{ $backgroundImg: string, $isActive: boolean }>`
  width: 6px;
  height: 6px;
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  transition: all 0.3s;
  margin-right: 4px;
`;

export default BigMenu;
